<template>
  <div class="c-resources-summary">
    <h2 class="c-resources-summary__heading" v-if="summaryHeading">
      {{summaryHeading}}
      <small>{{requestedItems.length > 0 ? `(${requestedItems.length})` : null}}</small>
    </h2>
    <div class="c-resources-summary__list">
      <div class="c-resource-item" v-for="item in requestedItems" v-bind:key="item.id">
        <p class="c-resource-item__info">
          <span class="c-resource-item__title">{{item.name}}</span>
          <span class="c-resource-item__label">{{item.label}}</span>
        </p>
        <div class="c-resource-item__actions">
          <input
            class="c-resource-item__quantity"
            type="number"
            v-on:change="updateQuantity($event, item.id)"
            :value="item.quantity"
          />
          <button class="c-resource-item__remove" v-on:click="removeItem($event, item.id)">
            <svg class="c-resource-item__remove-icon" focusable="false" aria-hidden="true">
              <use xlink:href="#bin" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "resources-summary",
  props: {
    summaryHeading: {
      required: false,
      type: String,
    },
    requestedItems: {
      required: false,
      type: Array,
    },
  },
  methods: {
    removeItem(e, id) {
      e.preventDefault();
      this.$emit("removeItem", id);
    },
    updateQuantity(e, id) {
      const value = e.target.value;
      console.log(id);

      if (value > 0) {
        this.$emit("updateQuantity", id, value);
      } else {
        this.$emit("removeItem", id);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/components/partnerhub/resources/form/ResourcesSummary.vue